import { ConfigType } from "../utils/requestAPI";

type GetAllClientAssociatedPrinter = {
  page?: number;
  limit?: number;
  search?: string;
};
type AssociatePrinterWithClient = {
  printerId?: string[];
};
const printerApi = {
  getAllPrinter: (params?: GetAllClientAssociatedPrinter): ConfigType => {
    return {
      url: "/printers",
      method: "get",
      params,
      config: { store: { action: "set", key: "printers.data" } },
    };
  },
  getAllClientAssociatedPrinter: (
    params: GetAllClientAssociatedPrinter,
  ): ConfigType => {
    return {
      url: "/printers/client-associate-printers",
      method: "get",
      params,
      config: { store: { action: "set", key: "printersList.data" } },
    };
  },
  associatePrinterWithClient: (
    data: AssociatePrinterWithClient,
  ): ConfigType => {
    return {
      url: "/printers/associate-printer",
      method: "post",
      data,
    };
  },

  getAllPrinterJobs: (params: { printerId?: string }): ConfigType => {
    return {
      url: "/printer-jobs",
      method: "get",
      params,
      // config: { store: { action: 'set', key: 'jobList.data' } },
    };
  },
  asignPrinter: (
    printJobId: string,
    data: { printerId: string },
  ): ConfigType => {
    return {
      url: `/printer-jobs/${printJobId}`,
      method: "patch",
      data,
      // config: { store: { action: 'set', key: 'jobList.data' } },
    };
  },

  getAllPrinterClient: (): ConfigType => {
    return {
      url: "/printer-jobs/printer-clients",
      method: "get",
      config: { store: { action: "set", key: "PrinterClientList.data" } },
    };
  },
  getAllPrinters: (): ConfigType => {
    return {
      url: "/printers",
      method: "get",
      // config: { store: { action: "set", key: "PrinterClientList.data" } },
    };
  },

  getPrinterClientDetailById: (clientId: string): ConfigType => {
    return {
      url: `/printer-jobs/client/${clientId}`,
      method: "get",
      config: { store: { action: "set", key: "singleClient.data" } },
    };
  },
  getPrinterJobById: (jobId: string): ConfigType => {
    return {
      url: `/printer-jobs/${jobId}`,
      method: "get",
      config: { store: { action: "set", key: "singleClient.data" } },
    };
  },
};

export default printerApi;
